import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/(main)/markets/MarketsPageClient.tsx");
